import { render } from "./BankCardManage.vue?vue&type=template&id=c67241fe&scoped=true"
import script from "./BankCardManage.vue?vue&type=script&lang=js"
export * from "./BankCardManage.vue?vue&type=script&lang=js"

import "./BankCardManage.vue?vue&type=style&index=0&id=c67241fe&lang=less&scoped=true"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c67241fe"]])

export default __exports__